<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('product.catalogue') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="toolbar" v-if="dbFilter.length !== 0">
			<template v-if="!hasShowDeletedItems">
				<button v-access:can="[Const.PERMISSION_ROLE_EDIT_ITEM]" id="table_toolbar_add" :title="$t('add.item')">
					<span uk-icon="plus"></span>
					<span class="title">{{ $t('add.item') }}</span>
				</button>
				<button id="table_toolbar_all" class="table_toolbar_all" :title="$t('all.items')">
					<span uk-icon="list"></span>
					<span class="title">{{ $t('all.items') }}</span>
				</button>
				<button id="table_toolbar_selected_items" :title="$t('selected.items')">
					<span uk-icon="check"></span>
					<span class="title">{{ $t('selected.items') }}</span>
					<span id="table_toolbar_selected_count">...</span>
				</button>
				<button id="table_toolbar_selected_clear" class="red" :title="$t('clear.selected.items')">
					<span uk-icon="clear"></span>
					<span class="title">{{ $t('clear.selected.items') }}</span>
				</button>
				<button v-access:can="[Const.PERMISSION_ROLE_EDIT_ITEM]" id="table_toolbar_batch_update"
						:title="$t('items.batch.update')">
					<span uk-icon="copy"></span>
					<span class="title">{{ $t('items.batch.update') }}</span>
				</button>
			</template>
			<button v-if="hasShowDeletedItems" class="table_toolbar_all" :title="$t('all.items')" @click="showAllItems">
				<span uk-icon="list"></span>
				<span class="title">{{ $t('all.items') }}</span>
			</button>
			<button v-if="!hasShowDeletedItems" v-access:can="[Const.PERMISSION_ROLE_DELETE_ITEM]" id="deleted-items" :title="$t('deleted.items')" @click="showDeletedItems">
				<span uk-icon="trash"></span>
				<span v-if="isLoadDeletedItems" class="table_deleted_items-load loading fa fa-refresh fa-spin"></span>
				<span class="title">{{ $t('deleted.items') }}</span>
			</button>
		</div>

		<div class="table_search_phrase" v-if="dbFilter.length !== 0">
			<div id="search_phrase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="table_search collapse">
					<div class="row">
						<h4 class="uk-text-normal search_title">
							{{ $t('filter') }}
							<div class="uk-float-right section_settings">
								<span class="uk-margin-small-right" uk-icon="icon: cog; ratio: .8"></span>
								<span class="uk-collapse" uk-icon="icon: chevron-up; ratio: .8"></span>
							</div>
						</h4>
					</div>
					<div class="row">
						<TableFilter
							:item-structure="$store.getters.getItemStructure"
							:db-filter="dbFilter"
							:classificators="classificators"
							:measurement-units="measurementUnits"
							:show="show"
						/>
					</div>
					<div class="row">
						<div class="search_button">
							<button id="search" class="uk-button uk-button-primary uk-button-small">
								{{ $t('search') }}
							</button>
							<button id="search-clear" class="uk-button uk-button-default uk-button-small">
								{{ $t('clear.filters') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-access:can="[Const.PERMISSION_ROLE_EXPORT]" id="export-form" class="modal fade modal-window"
			 tabindex="-1"
			 role="dialog"
			 aria-labelledby="person-users-manager" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content modal-window_rect">

					<div class="export-variant">
						<div class="row">
							<div class="col-sm-6">
								<label>
									<input type="radio" name="export" data-type="selected">
									{{ $t('export.selected') }}
								</label>
							</div>
							<div class="col-sm-6">
								<label>
									<input type="radio" name="export" data-type="all" checked="checked">
									{{ $t('export.all') }}
								</label>
							</div>
						</div>
					</div>

					<div class="export">
						<div class="row">
							<div class="col-sm-6">
								<div class="export-types">
									<ul id="export-types-list"
										class="nav nav-tabs nav-stacked attribute-groups"></ul>
								</div>
							</div>
							<div class="col-sm-6">
								<div class="export-templates">
									<div id="export-templates-list" class="tab-content"></div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>


		<div v-access:can="[Const.PERMISSION_ROLE_EDIT_ITEM]" id="batch-update-form" class="modal fade modal-window"
			 tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content modal-window_rect">
					<div class="modal-body">
						<div class="form">
							<div class="form-body">

								<div id="dictionary-add-form">
									<div id="dictionary-value-area"><textarea id="new-dict-value" rows="2"></textarea>
									</div>
									<button id="dictionary-save-button" class="button button-neutral">
										{{ $t('save') }}
									</button>
								</div>

								<div class="tab-content">

									<div class="col-sm-12">
										<div class="multicheckbox-editor" id="batch-update-multicheckbox"
											 max-count="-1">
											<label>
												{{ $t('attributes') }}
											</label>
											<div tabindex="0"
												 class="attribute-editor mcb-drop-down-btn fa fa-list-ul"></div>
											<div class="mcb-item-list">
												<div class="mcb-controls">
													<div class="mcb-clear" tabindex="0"></div>
													<input class="mcb-search" type="text" tabindex="-1">
													<button class="button_reset fa fa-times" tabindex="-1"></button>
												</div>
												<ul class="checkbox-list"></ul>
												<ul class="checkbox-sublist"></ul>
											</div>
										</div>
									</div>

									<BatchUpdateModal/>

									<div class="batch-update-button">
										<button id="batch-update-btn"
												class="uk-button uk-button-primary uk-button-small">
											{{ $t('update') }}
										</button>
										<button id="batch-update-cancel"
												class="uk-button uk-button-default uk-button-small">
											{{ $t('cancel') }}
										</button>
									</div>

									<div class="row">
										<div class="col-xs-12">
											<div class="batch-help-block">
												<i class="batch-action-add"></i>
												<p>{{ $t('batch.update.help.block.add') }}</p>
											</div>
											<div class="batch-help-block">
												<i class="batch-action-remove"></i>
												<p>{{ $t('batch.update.help.block.remove') }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li>
					<a tabindex="-1">
						{{ $t('item.view') }}
					</a>
				</li>
				<li v-access:can="[Const.PERMISSION_ROLE_EDIT_ITEM]">
					<a tabindex="-1">
						{{ $t('item.edit') }}
					</a>
				</li>
				<li v-access:can="[Const.PERMISSION_ROLE_EDIT_ITEM]">
					<a tabindex="-1">
						{{ $t('item.create.by.template') }}
					</a>
				</li>
				<li v-access:can="[Const.PERMISSION_ROLE_DELETE_ITEM]">
					<a tabindex="-1">
						{{ $t('delete.item') }}
					</a>
				</li>
			</ul>
		</div>

		<div id="context-menu-deleted" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li>
					<a tabindex="-1">
						{{ $t('item.view') }}
					</a>
				</li>
				<li v-access:can="[Const.PERMISSION_ROLE_EDIT_ITEM]">
					<a tabindex="-1">
						{{ $t('restore.item') }}
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { CONFIGURATIONS_ITEM_TABLE, CONFIGURATIONS_TABLE_FILTER } from 'actions/configurations'
import BatchUpdateModal from 'components/modal/BatchUpdateModal'
import TableFilter from 'components/table-filter/TableFilter'
import { USER_CONFIG } from 'actions/user'
import { resizeTableHeight, Table } from '@/core/support_gui_components/table/table'
import { TableDataPreparer } from '@/core/support_gui_components/table/table_data_preparer'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { configureExport } from '@/core/migration/ExportManager'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex, showMessageAlert } from '@/core/shared'
import { attachToolbarControls, unbindToolbarControls, setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { enableAllHotkeysForAttributeEditors, enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import http from 'utils/http'

export default {
	name: 'ItemTable',
	metaInfo () {
		return {
			title: this.$t('product.catalogue')
		}
	},
	props: [
		'externalFilter',
		'mode'
	],
	components: {
		TableFilter,
		BatchUpdateModal
	},
	data () {
		return {
			dbFilter: [],
			classificators: {},
			measurementUnits: {},
			show: false,
			hasShowDeletedItems: false,
			isLoadDeletedItems: false
		}
	},
	mounted () {
		this.initTable()
	},
	methods: {
		initTable () {
			const vm = this
			this.$store.dispatch(CONFIGURATIONS_TABLE_FILTER)
				.then(() => {
					this.classificators = this.$store.getters.getClassificators
					this.measurementUnits = this.$store.getters.getMeasurementUnits
					this.show = true
				})
				.then(() => {
					this.$store.dispatch(CONFIGURATIONS_ITEM_TABLE)
						.then(() => {
							this.dbFilter = this.$store.getters.getDbFilter
						})
						.then(() => {
							window.itemStructure = JSON.parse(JSON.stringify(this.$store.getters.getItemStructure))
							window.tableColumns = JSON.parse(JSON.stringify(this.$store.getters.getTableColumn))

							if (vm.hasShowDeletedItems) {
								vm.hasShowDeletedItems = false
							}

							this.$store.dispatch(USER_CONFIG, 'itemsTable.tableState')
								.then((config) => {
									window.table = new Table('itemsTable', {
											selector: '#table',
											columns: tableColumns,
											externalFilter: (!_.isEmpty(this.externalFilter)) ? this.externalFilter : false,
											dynamicLoading: true,
											contextMenu: '#context-menu',
											exportButton: true,
											doubleClickMode: 'edit',
											dragAndDropSupport: true,
											restoringSupport: true,
											sortingSupport: true,
											cellsSelectionsSupport: true,
											itemsSelectionsSupport: true,
											frozenFirstColumn: true,
											saveFiltersSupport: true
										},
										{
											contextMenu: {
												1: function (item) {
													var targetUrn = '/item-view/' + item.id
													window.open(targetUrn)
												},
												2: function (item, attribute) {
													var targetUrn = '/item-edit/' + item.id + '?activeAttribute=' + attribute
													window.open(targetUrn)
												},
												3: function (item) {
													location.href = '/item-create?sourceItemId=' + item.id
												},
												4: function (item) {
													vm.deleteItem(item)
												}
											},
											doubleClick: {
												'edit': function (item, table) {
													var targetUrn = 'item-edit/' + item.id
													if (!_.contains(table.CUSTOM_ATTRIBUTES, table.selectedAttribute)) {
														targetUrn += '?activeAttribute=' + table.selectedAttribute
													}
													location.href = targetUrn
												},
												'view': function (item, table) {
													var targetUrn = 'item-view/' + item.id
													location.href = targetUrn
												}
											}
										},
										function (data) {
											new TableDataPreparer(data, itemStructure)
										}
									)

									if (this.mode === 'deleted') {
										this.showDeletedItems()
									} else {
										table.setSavedState(config)
										initFilterForm(itemStructure, table)

										configureExport()

										table.setDataUrl(window.urlContext + 'items/table-format/load')
										table.setDataIDsUrl(window.urlContext + 'items/ids')
										table.setDataSortUrl(window.urlContext + 'items/sort')
										table.initTable()

										bindResetButton()
										removeTabindex()

										setToolbarMode(table.selectedItemsMode)
										attachToolbarControls(table, itemStructure, this)
										enableHotkeyForSearch(itemStructure, table)
									}
								})
								.catch(error => {
									console.log(error)
									this.rollbar.error('USER_CONFIG itemsTable', error)
								})

							enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })

							//for batch update
							enableAllHotkeysForAttributeEditors()

							$(window).resize(function () {
								resizeTableHeight()
								table.frozenTableElements.setFrozenHeaderCellsWidth()
								table.frozenTableElements.setFrozenColumnCellsHeight()
							})
						})
				})
				.catch(error => {
					console.log(error)
					this.rollbar.error('CONFIGURATIONS_TABLE_FILTER', error)
				})
		},
		deleteItem (item) {
			const vm = this
			Swal.fire({
				title: this.$t('are.you.sure.you.want.to.delete.item'),
				allowOutsideClick: true,
				confirmButtonText: this.$t('ok'),
				showCancelButton: true,
				cancelButtonText: this.$t('cancel'),
				buttonsStyling: false,
				allowEnterKey: true,
				showClass: {
					popup: ''
				},
				hideClass: {
					popup: ''
				},
				customClass: {
					confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
					cancelButton: 'uk-button uk-button-default uk-button-small',
				}
			}).then(function (result) {
				if (result.value) {
					const companyId = vm.$store.getters.getProfile.companyId
					const params = new URLSearchParams()
					params.append('companyId', companyId)
					params.append('ids', JSON.stringify([item.id]))

					http.post('/items/delete', params, {
						headers: {
							'content-type': 'application/x-www-form-urlencoded'
						}
					})
						.then(() => {
							showMessageAlert(vm.$t('success'), 'success')
							table.initTable()
						})
						.catch(error => {
							showMessageAlert(error.data[0], 'danger')
							vm.rollbar.error('delete item itemsTable', error)
						})
				}
			})
		},
		showAllItems () {
			this.initTable()
			if (this.mode === 'deleted') {
				this.$router.push('/item-table')
			}
		},
		showDeletedItems () {
			this.isLoadDeletedItems = true
			setTimeout(() => {
				const table = window.table
				const vm = this
				this.hasShowDeletedItems = !this.hasShowDeletedItems

				table.isSaveTableState = false
				table.isSaveFilterState = false
				table.filters = {
					search_phrase: {},
					action: { val: "DELETE" },
					last_version: { val: true }
				}
				table.destroyContextMenu()
				table.contextMenu = '#context-menu-deleted'
				const contextMenu = {
					1: function (item) {
						window.open('/item-history-view/' + item.id)
					},
					2: function (item) {
						vm.restoreItem(item.id)
					}
				}
				table.setContextMenuCallbackObject(contextMenu)
				table.exportButton = false
				table.destroyExportImportButton()

				table.setDataUrl(window.urlContext + 'items/history/table-format/load')
				table.setDataIDsUrl(window.urlContext + 'items/history/ids')
				table.setDataSortUrl(window.urlContext + 'items/history/sort')
				table.initTable()

				this.isLoadDeletedItems = false

				unbindToolbarControls(table, this.itemStructure, this)
			}, 100)
		},
		restoreItem (id) {
			const vm = this
			http.post('/items/history/state/rollback', `id=${id}`, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			}).then(function (res) {
				showMessageAlert(vm.$t('success'), 'success', res.data.message)
			}).catch(function (error) {
				showMessageAlert('error', 'danger', error.response.data)
			})
		}
	}
}
</script>

<style scoped>
.multicheckbox-editor .mcb-drop-down-btn {
	position: relative;
}

.batch-help-block:nth-child(1) {
	margin-top: 10px;
}

.batch-help-block p {
	display: inline-block;
	margin: 0 5px;
	font-size: 12px;
}

.batch-action-add, .batch-action-remove {
	border: 1px solid #cccccc;
	border-radius: 2px;
	margin: 2px;
	padding: 2px;
	min-width: 15px;
	font-family: FontAwesome, sans-serif;
	font-size: 11px;
	text-align: center;
}

.batch-action-add::before {
	content: "\f067";
}

.batch-action-remove::before {
	content: "\f00d";
}

</style>
